const baseUrl = "https://api.theathletesapp.com/v1";
const projectSettings = {
  baseUrl,
  baseImageUrl: `${baseUrl}/users/getimage?image`,
  baseVideoUrl: `${baseUrl}/users/getVideo?video=`,
  iconBaseUrl72: `${baseUrl}/users/getimage?image=72x72/`,
  iconBaseUrl128: `${baseUrl}/users/getimage?image=128x128/`,
  stripePublicKey: "pk_live_51Ji2N5Ivdu8eXIw57TmaT5727W2Qkyu5fPsmSUnvxH6E7vAScQsrD0zA2AdbuSM8WDAr0Ih1dWuWbk0z2CsLjXK5007PS1V8vR",
  giphyApiKey: "hbT24RW5H4xmxVlAmf9DGuNsGlE3XVei",
  firebaseApiKey:
    "BDzUVc2h_DREvBDS1UaznOxpzIqWn63oLWsN6N8z2fApvFaX8-SeqOubnOLfXdnQ2JI4T16lBcSzi-An0EIIYBU",
};

export default projectSettings;
